import { makeStyles, Paper, TextField, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionTitle } from '../../components/SectionTitle';
import { DefaultInputProps } from '../../types/types';
import { globalStyles } from '../../style/GlobalStyles';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         formControl: {
//             margin: theme.spacing(1),
//             // minWidth: 320,
//         },
//         textField: {
//             marginLeft: theme.spacing(1),
//             marginRight: theme.spacing(1),
//             width: 200,
//         },
//         bottomControlLabel: {
//             verticalAlign: 'bottom',
//         }
//     }),
// );

export default function Collaboratore2(props: DefaultInputProps) {
    // const classes = useStyles();
    const gClasses = globalStyles();
    const { state } = props;

    return (
        <React.Fragment>
            {state.datiCollaboratore2.nomeCognome2 !== undefined && state.datiCollaboratore2.nomeCognome2 !== "" ?
                (<Paper className={gClasses.mainPaper}>
                    <SectionTitle text="Collaboratore 2"></SectionTitle>
                    <TextField
                        label="Collaboratore 2"
                        value={state.datiCollaboratore2.nomeCognome2}
                        className={gClasses.textFieldReadOnly}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{tabIndex: -1}}
                        margin="normal"
                    />
                    <NumberField
                        name=""
                        label="Rivalsa Contr. IVS"
                        value={state.collaboratore2.rivalsaContrIvs_H60}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <Typography variant="h5">Redditi</Typography>
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E111"
                        label="Pensione"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E123}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E112"
                        label="Lav. dipendente e assimilati"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E124}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E113"
                        label="Assimilati lav. dipendente"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E125}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E114"
                        label="Diversi lettere i) e l)"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E126}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E115"
                        label="Fabbricati locati"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E127}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E116"
                        label="Altri"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E128}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E117"
                        label="Abitazione principale"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E129}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditiDiversiDallaPartecipazione_E119"
                        label="Redditi a cedolare secca"
                        value={state.datiCollaboratore2.redditiDiversiDaImpresa_LavAutonomo_E131}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditi_E73"
                        label="Reddito complessivo"
                        value={state.collaboratore2.redditi_E73}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditi_E74"
                        label="Redd. compl. per detraz."
                        value={state.collaboratore2.redditi_E74}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="oneriDeducibiliredditi_I35"
                        label="Oneri deducibili"
                        value={state.collaboratore2.oneriDeducibiliredditi_I62}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="redditoImponibile_I36"
                        label="Reddito imponibile"
                        value={state.collaboratore2.redditoImponibile_I63}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="irpefLorda_I37"
                        label="Irpef lorda"
                        value={state.collaboratore2.irpefLorda_I64}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <Typography variant="h5">Detrazioni</Typography>
                    <NumberField
                        name="familiari_I39"
                        label="Familiari a carico"
                        value={state.collaboratore2.familiari_I66}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="lavDip_I40"
                        label="Lavoro dipend."
                        value={state.collaboratore2.lavDip_I67}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="pensione_I41"
                        label="Pensione"
                        value={state.collaboratore2.pensione_I68}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="lavNonDip_I42"
                        label="Lav. non dipend."
                        value={state.collaboratore2.lavNonDip_I69}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="altriDatiPersonali_L115"
                        label="Altre"
                        value={state.datiCollaboratore2.altriDatiPersonali_L127}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="totDetr_I44"
                        label="Tot. Detrazioni"
                        value={state.collaboratore2.totDetr_I71}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="irpefNetta_M40"
                        label="Irpef netta"
                        value={state.collaboratore2.irpefNetta_M67}
                        readOnly={true}
                        className={gClasses.textField}
                    />
                    <Typography variant="h5">Addizionali Irpef</Typography>
                    <NumberField
                        name="regionale_K44"
                        label="Regionale"
                        value={state.collaboratore2.regionale_K71}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                    <NumberField
                        name="comunale_M44"
                        label="Comunale"
                        value={state.collaboratore2.comunale_M71}
                        readOnly={true}
                        className={gClasses.textFieldReadOnly}
                    />
                </Paper>) : <p></p>}
        </React.Fragment>
    );
}